import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { AutocompleteInput } from './AutocompleteInput';

export const ValidationForm = ({
  fonction, setFonction,
  niveau, setNiveau,
  typeQuestionnaire, setTypeQuestionnaire,
  client, setClient,
  interlocuteurClient, setInterlocuteurClient,
  refAo, onRefAoChange,
  duplicateInfo, errors,
  saving, onSave, onLaunchTest
}) => {
  const navigate = useNavigate();

  return (
    <div className="eva-card" data-testid="validation-form">
      <h3 className="text-lg font-semibold text-white mb-6">Validation du questionnaire</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div>
          <label className="eva-label">Fonction / Poste *</label>
          <input
            type="text"
            value={fonction}
            onChange={(e) => setFonction(e.target.value)}
            className={`eva-input ${errors.fonction ? 'border-red-500' : ''}`}
            data-testid="save-fonction-input"
          />
        </div>

        <div>
          <label className="eva-label">Niveau *</label>
          <select
            value={niveau}
            onChange={(e) => setNiveau(e.target.value)}
            className={`eva-input ${errors.niveau ? 'border-red-500' : ''}`}
            data-testid="save-niveau-select"
          >
            <option value="">Sélectionner</option>
            <option value="Junior">Junior</option>
            <option value="Confirmé">Confirmé</option>
            <option value="Senior">Senior</option>
            <option value="Expert">Expert</option>
          </select>
        </div>

        <div>
          <label className="eva-label">Type de questionnaire *</label>
          <select
            value={typeQuestionnaire}
            onChange={(e) => setTypeQuestionnaire(e.target.value)}
            className={`eva-input ${errors.typeQuestionnaire ? 'border-red-500' : ''}`}
            data-testid="type-select"
          >
            <option value="">Sélectionner</option>
            <option value="Générique">Générique</option>
            <option value="Appel d'offres">Appel d'offres</option>
          </select>
        </div>

        <div>
          <label className="eva-label">Client (optionnel)</label>
          <AutocompleteInput
            value={client}
            onChange={(val) => setClient(val)}
            endpoint="/autocomplete/entreprises"
            className="eva-input"
            dataTestId="client-input"
          />
        </div>

        <div>
          <label className="eva-label">Réf. AO (optionnel)</label>
          <AutocompleteInput
            value={refAo}
            onChange={onRefAoChange}
            endpoint="/autocomplete/ref_ao"
            className="eva-input"
            placeholder="Référence appel d'offres"
            dataTestId="ref-ao-input"
          />
          {duplicateInfo && (
            <div className="mt-2 p-3 bg-[#FFFBEB] border border-[#F59E0B]/30 rounded-lg" data-testid="duplicate-warning">
              <div className="flex items-start gap-2">
                <AlertTriangle size={16} className="text-[#F59E0B] mt-0.5 shrink-0" />
                <div className="flex-1">
                  <p className="text-sm font-medium text-[#92400E]">
                    Un questionnaire existe déjà pour cette réf. AO
                  </p>
                  <p className="text-xs text-[#92400E]/80 mt-1">
                    {duplicateInfo.fonction} — {duplicateInfo.niveau} — {duplicateInfo.client || 'Sans client'}
                    {duplicateInfo.test_count > 0 && ` — ${duplicateInfo.test_count} test(s) passé(s)`}
                  </p>
                  <button
                    type="button"
                    onClick={() => navigate(`/lancer-test/${duplicateInfo.id}`)}
                    className="mt-2 text-sm font-medium text-white bg-[#0B132B] border border-white/10 px-3 py-1.5 rounded-lg hover:bg-white/5 transition-colors"
                    data-testid="use-existing-button"
                  >
                    Utiliser le questionnaire existant
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="md:col-span-2">
          <label className="eva-label">Opérationnel (optionnel)</label>
          <AutocompleteInput
            value={interlocuteurClient}
            onChange={(val) => setInterlocuteurClient(val)}
            endpoint="/autocomplete/interlocuteurs"
            className="eva-input"
            dataTestId="interlocuteur-input"
          />
        </div>
      </div>

      {Object.keys(errors).length > 0 && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md" data-testid="error-message">
          <p className="text-sm text-red-600">Vous n'avez pas complété un champ obligatoire</p>
        </div>
      )}

      <div className="flex gap-4">
        <button
          onClick={onSave}
          disabled={saving}
          className="eva-btn-secondary"
          data-testid="save-button"
        >
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </button>
        <button
          onClick={onLaunchTest}
          disabled={saving}
          className="eva-btn-primary"
          data-testid="launch-test-button"
        >
          {saving ? 'Lancement...' : 'Lancer le test'}
        </button>
      </div>
    </div>
  );
};
